export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-11-07 at 8.55.15 PM.3643bc98.jpeg";